/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCycleSubjectDtoApiResponse } from '../../models/amoxcalli-cycle-subject-dto-api-response';
import { AmoxcalliUpdateCycleSubjectDto } from '../../models/amoxcalli-update-cycle-subject-dto';

export interface ApiCycleSubjectsIdPut$Plain$Params {
  id: string;
      body?: AmoxcalliUpdateCycleSubjectDto
}

export function apiCycleSubjectsIdPut$Plain(http: HttpClient, rootUrl: string, params: ApiCycleSubjectsIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiCycleSubjectsIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>;
    })
  );
}

apiCycleSubjectsIdPut$Plain.PATH = '/api/cycle-subjects/{id}';
